import * as React from 'react';

import { PromoItem } from '../../components/PromoItem';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';

interface IPromoContainerProps {
  onClick(promo: IPromoInfo): void;
  promo: IPromoInfo;
}

export const PromoItemContainer: React.FC<IPromoContainerProps> = ({ onClick, promo }) => {
  const handleClick = React.useCallback(() => {
    onClick(promo);
  }, [promo, onClick]);

  return <PromoItem promo={promo} onClick={handleClick} />;
};
